/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DomainAvailabilityResponse,
  SsoConfigRequest,
  TenantEnrollmentRequest,
  TenantEnrollmentResponse,
} from '../models/index';
import {
    DomainAvailabilityResponseFromJSON,
    DomainAvailabilityResponseToJSON,
    SsoConfigRequestFromJSON,
    SsoConfigRequestToJSON,
    TenantEnrollmentRequestFromJSON,
    TenantEnrollmentRequestToJSON,
    TenantEnrollmentResponseFromJSON,
    TenantEnrollmentResponseToJSON,
} from '../models/index';

export interface ActivateTenantRequest {
    tenantId: string;
    sessionId?: string;
}

export interface ChangeSsoProviderRequest {
    ssoConfigRequest: SsoConfigRequest;
    sessionId?: string;
}

export interface CheckDomainAvailabilityRequest {
    domain: string;
}

export interface EnrollTenantRequest {
    tenantEnrollmentRequest: TenantEnrollmentRequest;
}

export interface GetEnrollmentStatusRequest {
    tenantId: string;
    sessionId?: string;
}

export interface MigrateToLocalRequest {
    sessionId?: string;
}

export interface MigrateToSsoRequest {
    ssoConfigRequest: SsoConfigRequest;
    sessionId?: string;
}

export interface TestSsoConfigurationRequest {
    ssoConfigRequest: SsoConfigRequest;
    sessionId?: string;
}

export interface UpdateSsoConfigurationRequest {
    ssoConfigRequest: SsoConfigRequest;
    sessionId?: string;
}

export interface VerifySsoConfigurationRequest {
    sessionId?: string;
}

/**
 * TenantEnrollmentApi - interface
 * 
 * @export
 * @interface TenantEnrollmentApiInterface
 */
export interface TenantEnrollmentApiInterface {
    /**
     * Activate a tenant after successful verification
     * @summary Activate tenant
     * @param {string} tenantId Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEnrollmentApiInterface
     */
    activateTenantRaw(requestParameters: ActivateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>>;

    /**
     * Activate a tenant after successful verification
     * Activate tenant
     */
    activateTenant(requestParameters: ActivateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse>;

    /**
     * Change SSO provider for the current customer (e.g., from Azure to Okta)
     * @summary Change SSO provider
     * @param {SsoConfigRequest} ssoConfigRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEnrollmentApiInterface
     */
    changeSsoProviderRaw(requestParameters: ChangeSsoProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>>;

    /**
     * Change SSO provider for the current customer (e.g., from Azure to Okta)
     * Change SSO provider
     */
    changeSsoProvider(requestParameters: ChangeSsoProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse>;

    /**
     * Check if a domain is available for tenant enrollment
     * @summary Check domain availability
     * @param {string} domain Domain to check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEnrollmentApiInterface
     */
    checkDomainAvailabilityRaw(requestParameters: CheckDomainAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainAvailabilityResponse>>;

    /**
     * Check if a domain is available for tenant enrollment
     * Check domain availability
     */
    checkDomainAvailability(requestParameters: CheckDomainAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainAvailabilityResponse>;

    /**
     * Enroll a new tenant with self-service flow
     * @summary Enroll new tenant
     * @param {TenantEnrollmentRequest} tenantEnrollmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEnrollmentApiInterface
     */
    enrollTenantRaw(requestParameters: EnrollTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>>;

    /**
     * Enroll a new tenant with self-service flow
     * Enroll new tenant
     */
    enrollTenant(requestParameters: EnrollTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse>;

    /**
     * Returns whether Azure Enterprise App (multi-tenant) mode is available.  Customers can choose between: 1. **Enterprise App** (if available): Only requires tenant ID, uses shared enterprise application 2. **App Registration**: Requires tenant ID, client ID, and client secret (customer\'s own app registration)  **Response Fields:** - `enabled`: Whether Enterprise App mode is available/enabled - `endpointType`: Multi-tenant endpoint type (\"organizations\" or \"common\") when enabled - `requiresClientCredentials`: Whether clientId/clientSecret are required when NOT using enterprise app  **Frontend Usage:** - Call this endpoint before showing SSO configuration form - If `enabled=true`, show a toggle/choice: \"Use Enterprise App\" or \"Use My Own App Registration\" - If customer chooses \"Use Enterprise App\", only show tenantId field - If customer chooses \"Use My Own App Registration\" or `enabled=false`, show tenantId, clientId, and clientSecret fields - Set `useEnterpriseApp=true` in the request when customer chooses enterprise app option 
     * @summary Get Azure Enterprise App configuration status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEnrollmentApiInterface
     */
    getAzureEnterpriseAppStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns whether Azure Enterprise App (multi-tenant) mode is available.  Customers can choose between: 1. **Enterprise App** (if available): Only requires tenant ID, uses shared enterprise application 2. **App Registration**: Requires tenant ID, client ID, and client secret (customer\'s own app registration)  **Response Fields:** - `enabled`: Whether Enterprise App mode is available/enabled - `endpointType`: Multi-tenant endpoint type (\"organizations\" or \"common\") when enabled - `requiresClientCredentials`: Whether clientId/clientSecret are required when NOT using enterprise app  **Frontend Usage:** - Call this endpoint before showing SSO configuration form - If `enabled=true`, show a toggle/choice: \"Use Enterprise App\" or \"Use My Own App Registration\" - If customer chooses \"Use Enterprise App\", only show tenantId field - If customer chooses \"Use My Own App Registration\" or `enabled=false`, show tenantId, clientId, and clientSecret fields - Set `useEnterpriseApp=true` in the request when customer chooses enterprise app option 
     * Get Azure Enterprise App configuration status
     */
    getAzureEnterpriseAppStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get enrollment status for a tenant
     * @summary Get enrollment status
     * @param {string} tenantId Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEnrollmentApiInterface
     */
    getEnrollmentStatusRaw(requestParameters: GetEnrollmentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>>;

    /**
     * Get enrollment status for a tenant
     * Get enrollment status
     */
    getEnrollmentStatus(requestParameters: GetEnrollmentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse>;

    /**
     * Migrate the current customer from SSO back to local authentication
     * @summary Migrate to local authentication
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEnrollmentApiInterface
     */
    migrateToLocalRaw(requestParameters: MigrateToLocalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>>;

    /**
     * Migrate the current customer from SSO back to local authentication
     * Migrate to local authentication
     */
    migrateToLocal(requestParameters: MigrateToLocalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse>;

    /**
     * Migrate the current customer from local authentication to SSO
     * @summary Migrate to SSO
     * @param {SsoConfigRequest} ssoConfigRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEnrollmentApiInterface
     */
    migrateToSsoRaw(requestParameters: MigrateToSsoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>>;

    /**
     * Migrate the current customer from local authentication to SSO
     * Migrate to SSO
     */
    migrateToSso(requestParameters: MigrateToSsoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse>;

    /**
     * Test SSO configuration without creating or modifying any resources
     * @summary Test SSO configuration
     * @param {SsoConfigRequest} ssoConfigRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEnrollmentApiInterface
     */
    testSsoConfigurationRaw(requestParameters: TestSsoConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>>;

    /**
     * Test SSO configuration without creating or modifying any resources
     * Test SSO configuration
     */
    testSsoConfiguration(requestParameters: TestSsoConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse>;

    /**
     * Update SSO configuration for the current customer
     * @summary Update SSO configuration
     * @param {SsoConfigRequest} ssoConfigRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEnrollmentApiInterface
     */
    updateSsoConfigurationRaw(requestParameters: UpdateSsoConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>>;

    /**
     * Update SSO configuration for the current customer
     * Update SSO configuration
     */
    updateSsoConfiguration(requestParameters: UpdateSsoConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse>;

    /**
     * Verify SSO configuration for the current customer
     * @summary Verify SSO configuration
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEnrollmentApiInterface
     */
    verifySsoConfigurationRaw(requestParameters: VerifySsoConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>>;

    /**
     * Verify SSO configuration for the current customer
     * Verify SSO configuration
     */
    verifySsoConfiguration(requestParameters: VerifySsoConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse>;

}

/**
 * 
 */
export class TenantEnrollmentApi extends runtime.BaseAPI implements TenantEnrollmentApiInterface {

    /**
     * Activate a tenant after successful verification
     * Activate tenant
     */
    async activateTenantRaw(requestParameters: ActivateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling activateTenant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/enrollment/tenant/{tenantId}/activate`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Activate a tenant after successful verification
     * Activate tenant
     */
    async activateTenant(requestParameters: ActivateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse> {
        const response = await this.activateTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change SSO provider for the current customer (e.g., from Azure to Okta)
     * Change SSO provider
     */
    async changeSsoProviderRaw(requestParameters: ChangeSsoProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>> {
        if (requestParameters['ssoConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'ssoConfigRequest',
                'Required parameter "ssoConfigRequest" was null or undefined when calling changeSsoProvider().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/enrollment/change-sso-provider`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SsoConfigRequestToJSON(requestParameters['ssoConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Change SSO provider for the current customer (e.g., from Azure to Okta)
     * Change SSO provider
     */
    async changeSsoProvider(requestParameters: ChangeSsoProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse> {
        const response = await this.changeSsoProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if a domain is available for tenant enrollment
     * Check domain availability
     */
    async checkDomainAvailabilityRaw(requestParameters: CheckDomainAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainAvailabilityResponse>> {
        if (requestParameters['domain'] == null) {
            throw new runtime.RequiredError(
                'domain',
                'Required parameter "domain" was null or undefined when calling checkDomainAvailability().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/enrollment/domain/check/{domain}`;
        urlPath = urlPath.replace(`{${"domain"}}`, encodeURIComponent(String(requestParameters['domain'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainAvailabilityResponseFromJSON(jsonValue));
    }

    /**
     * Check if a domain is available for tenant enrollment
     * Check domain availability
     */
    async checkDomainAvailability(requestParameters: CheckDomainAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainAvailabilityResponse> {
        const response = await this.checkDomainAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enroll a new tenant with self-service flow
     * Enroll new tenant
     */
    async enrollTenantRaw(requestParameters: EnrollTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>> {
        if (requestParameters['tenantEnrollmentRequest'] == null) {
            throw new runtime.RequiredError(
                'tenantEnrollmentRequest',
                'Required parameter "tenantEnrollmentRequest" was null or undefined when calling enrollTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/enrollment/tenant`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TenantEnrollmentRequestToJSON(requestParameters['tenantEnrollmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Enroll a new tenant with self-service flow
     * Enroll new tenant
     */
    async enrollTenant(requestParameters: EnrollTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse> {
        const response = await this.enrollTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns whether Azure Enterprise App (multi-tenant) mode is available.  Customers can choose between: 1. **Enterprise App** (if available): Only requires tenant ID, uses shared enterprise application 2. **App Registration**: Requires tenant ID, client ID, and client secret (customer\'s own app registration)  **Response Fields:** - `enabled`: Whether Enterprise App mode is available/enabled - `endpointType`: Multi-tenant endpoint type (\"organizations\" or \"common\") when enabled - `requiresClientCredentials`: Whether clientId/clientSecret are required when NOT using enterprise app  **Frontend Usage:** - Call this endpoint before showing SSO configuration form - If `enabled=true`, show a toggle/choice: \"Use Enterprise App\" or \"Use My Own App Registration\" - If customer chooses \"Use Enterprise App\", only show tenantId field - If customer chooses \"Use My Own App Registration\" or `enabled=false`, show tenantId, clientId, and clientSecret fields - Set `useEnterpriseApp=true` in the request when customer chooses enterprise app option 
     * Get Azure Enterprise App configuration status
     */
    async getAzureEnterpriseAppStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/enrollment/azure-enterprise-app-status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns whether Azure Enterprise App (multi-tenant) mode is available.  Customers can choose between: 1. **Enterprise App** (if available): Only requires tenant ID, uses shared enterprise application 2. **App Registration**: Requires tenant ID, client ID, and client secret (customer\'s own app registration)  **Response Fields:** - `enabled`: Whether Enterprise App mode is available/enabled - `endpointType`: Multi-tenant endpoint type (\"organizations\" or \"common\") when enabled - `requiresClientCredentials`: Whether clientId/clientSecret are required when NOT using enterprise app  **Frontend Usage:** - Call this endpoint before showing SSO configuration form - If `enabled=true`, show a toggle/choice: \"Use Enterprise App\" or \"Use My Own App Registration\" - If customer chooses \"Use Enterprise App\", only show tenantId field - If customer chooses \"Use My Own App Registration\" or `enabled=false`, show tenantId, clientId, and clientSecret fields - Set `useEnterpriseApp=true` in the request when customer chooses enterprise app option 
     * Get Azure Enterprise App configuration status
     */
    async getAzureEnterpriseAppStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAzureEnterpriseAppStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get enrollment status for a tenant
     * Get enrollment status
     */
    async getEnrollmentStatusRaw(requestParameters: GetEnrollmentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getEnrollmentStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/enrollment/tenant/{tenantId}/status`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Get enrollment status for a tenant
     * Get enrollment status
     */
    async getEnrollmentStatus(requestParameters: GetEnrollmentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse> {
        const response = await this.getEnrollmentStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Migrate the current customer from SSO back to local authentication
     * Migrate to local authentication
     */
    async migrateToLocalRaw(requestParameters: MigrateToLocalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/enrollment/migrate-to-local`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Migrate the current customer from SSO back to local authentication
     * Migrate to local authentication
     */
    async migrateToLocal(requestParameters: MigrateToLocalRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse> {
        const response = await this.migrateToLocalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Migrate the current customer from local authentication to SSO
     * Migrate to SSO
     */
    async migrateToSsoRaw(requestParameters: MigrateToSsoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>> {
        if (requestParameters['ssoConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'ssoConfigRequest',
                'Required parameter "ssoConfigRequest" was null or undefined when calling migrateToSso().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/enrollment/migrate-to-sso`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SsoConfigRequestToJSON(requestParameters['ssoConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Migrate the current customer from local authentication to SSO
     * Migrate to SSO
     */
    async migrateToSso(requestParameters: MigrateToSsoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse> {
        const response = await this.migrateToSsoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test SSO configuration without creating or modifying any resources
     * Test SSO configuration
     */
    async testSsoConfigurationRaw(requestParameters: TestSsoConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>> {
        if (requestParameters['ssoConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'ssoConfigRequest',
                'Required parameter "ssoConfigRequest" was null or undefined when calling testSsoConfiguration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/enrollment/test-sso`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SsoConfigRequestToJSON(requestParameters['ssoConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Test SSO configuration without creating or modifying any resources
     * Test SSO configuration
     */
    async testSsoConfiguration(requestParameters: TestSsoConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse> {
        const response = await this.testSsoConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update SSO configuration for the current customer
     * Update SSO configuration
     */
    async updateSsoConfigurationRaw(requestParameters: UpdateSsoConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>> {
        if (requestParameters['ssoConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'ssoConfigRequest',
                'Required parameter "ssoConfigRequest" was null or undefined when calling updateSsoConfiguration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/enrollment/sso-config`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SsoConfigRequestToJSON(requestParameters['ssoConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Update SSO configuration for the current customer
     * Update SSO configuration
     */
    async updateSsoConfiguration(requestParameters: UpdateSsoConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse> {
        const response = await this.updateSsoConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verify SSO configuration for the current customer
     * Verify SSO configuration
     */
    async verifySsoConfigurationRaw(requestParameters: VerifySsoConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEnrollmentResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/enrollment/verify-sso`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Verify SSO configuration for the current customer
     * Verify SSO configuration
     */
    async verifySsoConfiguration(requestParameters: VerifySsoConfigurationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEnrollmentResponse> {
        const response = await this.verifySsoConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
